import React, {useEffect,useContext} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction, toJS} from "mobx";
import PropTypes from "prop-types";
import {ComponentContext} from "../../contexts";
import FormField from "../Helpers/FormField";
import {checkbox, custom, input} from "../../utils/linker";
import TableFieldSelector from "./TableFieldSelector";
import Taglist from "../Helpers/Taglist/Taglist";

function CategorySettings(props) {
  const store = useLocalObservable(() => ({list: [], fetching: false, inited: false}));
  const compContext = useContext(ComponentContext);

  useEffect(() => {
    // mount
    compContext.fetchAllTableFields();
    compContext.fetchAllCategoryFields();
    return () => {
      // unmount
    }
  }, []);

  const curView=compContext.curView();
  return (
    <div>
      <FormField title="Поле с названием по умолчанию">
        {compContext.all_table_fields.inited?(
          <Taglist {...custom(curView, "default_name_field")} single={true} selected_code={"code"} visible={["name","code"]} fullList={compContext.all_table_fields.data.filter((item)=>{ return item.filter_type; })} />
        ):null}
      </FormField>

      <FormField title="Фильтр по умолчанию">
        {compContext.all_table_fields.inited?(
          <Taglist {...custom(curView, "default_filter_field")} single={true} selected_code={"code"} visible={["name","code"]} fullList={compContext.all_table_fields.data.filter((item)=>{ return item.filter_type; })} />
        ):null}
      </FormField>

      <FormField title="Картинка по умолчанию">
        {compContext.all_table_fields.inited?(
          <Taglist {...custom(curView, "default_img_field")} single={true} selected_code={"code"} visible={["name","code"]} fullList={compContext.allTablesFields().filter((item)=>{ return item.type_code === 'file'; })} />
        ):null}
      </FormField>

      <FormField title="Детальная ссылка по умолчанию">
        <input type="text" {...input(curView, "public_url")} className="w100" />
      </FormField>

      <FormField title="Использовать варианты" type="checkbox" input_id="chk_variants">
        <input id="chk_variants" type="checkbox" {...checkbox(curView, "use_variants")}  />
      </FormField>

      {curView.use_variants && compContext.all_category_fields.inited?(
        <FormField title="Одинаковые поля" description={"Данные поля будут изменяться у всех коллекции сразу"}>
          <Taglist {...custom(curView, "same_fields")} selected_code={"code"} visible={["name","code"]} fullList={compContext.all_category_fields.data} />
        </FormField>
      ):null}

      <div className="pbottom15 bold fs16 ptop10">Файлы</div>
      {compContext.storages.inited?(
        <FormField title="Хранилище для файлов">
          <span className="select w100"><select {...input(curView, "storage")}>
            {compContext.storages.data.map((item, ind)=>{
              return <option key={ind} value={item.id}>{item.name}</option>
            })}
          </select></span>
        </FormField>
      ):null}


      <div className="pbottom15 bold fs16 ptop10">Быстрые действия</div>
      <FormField title="Просмотр">
        <input type="text" {...input(curView, "qa_view")} className="w100" />
      </FormField>
      <FormField title="Добавление">
        <input type="text" {...input(curView, "qa_add")} className="w100" />
      </FormField>
    </div>
  )
};

CategorySettings.defaultProps = {};

CategorySettings.propTypes = {}

export default observer(CategorySettings);
